var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSend = function SvgSend(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.883 12H5.39m0 0-1.852 6.99a1.203 1.203 0 0 0 1.702 1.383l14.598-7.297a1.203 1.203 0 0 0 0-2.152L5.24 3.627A1.203 1.203 0 0 0 3.538 5.01L5.39 12Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSend);
export default ForwardRef;